import {
	img1,
	img1_p5,
	img2,
	img2_p5,
	img3,
	img3_p5,
	img4,
	img4_p5,
	img5,
	img5_p5,
	img6,
	img6_p5,
	img7,
	img7_p5,
	img8,
	img8_p5,
	img9,
	img10,
	img11,
} from '../assets';

const SWIPER_ITEMS_P3 = [
	{
		src: img1,
		alt: 'Крепление груза',
		title: 'Крепление груза',
		type: 1,
	},
	{
		src: img2,
		alt: 'Крепление груза',
		title: 'Крепление груза',
		type: 2,
	},
	{
		src: img3,
		alt: 'Крепление груза',
		title: 'Крепление груза',
		type: 3,
	},
	{
		src: img4,
		alt: 'Крепление груза',
		title: 'Крепление груза',
		type: 4,
	},
	{
		src: img5,
		alt: 'Крепление груза',
		title: 'Крепление груза',
		type: 5,
	},
	{
		src: img6,
		alt: 'Крепление груза',
		title: 'Крепление груза',
		type: 6,
	},
	{
		src: img7,
		alt: 'Крепление груза',
		title: 'Крепление груза',
		type: 7,
	},
	{
		src: img8,
		alt: 'Крепление груза',
		title: 'Крепление груза',
		type: 8,
	},
	{
		src: img9,
		alt: 'Крепление груза',
		title: 'Крепление груза',
		type: 9,
	},
	{
		src: img10,
		alt: 'Крепление груза',
		title: 'Крепление груза',
		type: 10,
	},
	{
		src: img11,
		alt: 'Крепление груза',
		title: 'Крепление груза',
		type: 11,
	},
];

const SWIPER_ITEMS_P5 = [
	{
		src: img1_p5,
		alt: 'Погрузочно-разгрузочные работы',
		title: 'Погрузочно-разгрузочные работы',
		type: 1,
	},
	{
		src: img2_p5,
		alt: 'Погрузочно-разгрузочные работы',
		title: 'Погрузочно-разгрузочные работы',
		type: 2,
	},
	{
		src: img3_p5,
		alt: 'Погрузочно-разгрузочные работы',
		title: 'Погрузочно-разгрузочные работы',
		type: 3,
	},
	{
		src: img4_p5,
		alt: 'Погрузочно-разгрузочные работы',
		title: 'Погрузочно-разгрузочные работы',
		type: 4,
	},
	{
		src: img5_p5,
		alt: 'Погрузочно-разгрузочные работы',
		title: 'Погрузочно-разгрузочные работы',
		type: 5,
	},
	{
		src: img6_p5,
		alt: 'Погрузочно-разгрузочные работы',
		title: 'Погрузочно-разгрузочные работы',
		type: 6,
	},
	{
		src: img7_p5,
		alt: 'Погрузочно-разгрузочные работы',
		title: 'Погрузочно-разгрузочные работы',
		type: 7,
	},
	{
		src: img8_p5,
		alt: 'Погрузочно-разгрузочные работы',
		title: 'Погрузочно-разгрузочные работы',
		type: 8,
	},
];

export {SWIPER_ITEMS_P3, SWIPER_ITEMS_P5};
